import { Typography, Box, Button } from "@anchor/react-components";
import { useMsal } from "@azure/msal-react";

function PageHeader(props) {
	const style = {
		background: "white",
		width: "100%",
		zIndex: "150",
		boxSizing: "border-box",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
	};
	const textStyle = {
		fontWeight: "500",
		fontSize: "16px",

	};
	const contentStyle = {
		display: "flex",
		justifycontent: "space-between",
	};

	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();

	const handleLogoutButtonClick = async () => {
		instance.logoutRedirect();
	}

	return (
		<header style={style}>
			<Box display="flex" width="100%">
				<Box p={3} flexGrow={1}>
					<Typography style={contentStyle} variant="body1" fontStyle="bold">
						<span> <img src="/maersk.svg" width={'102'} /> </span>  &nbsp; <span style={textStyle}> | EDI SUBSCRIPTION FILTERING </span>
					</Typography>
				</Box>
				{activeAccount ? (
					<Box p={3} flexGrow={1} align="right">
						<Typography variant="body1">
							Logged in as {activeAccount.username}
						</Typography>
						&nbsp;&nbsp;
						<Button
							appearance="default"
							id="primary"
							label="Logout"
							name="primary"
							onClick={handleLogoutButtonClick}
							title="LOGOUT"
							variant="filled"
							fit="small"
						/>
					</Box>
				) : null}
			</Box>
		</header>
	)
}
export default PageHeader;